<app-mq-header></app-mq-header>
<router-outlet></router-outlet>
<app-service-now-chat-bubble *ngIf="isProd && isAuthenticated"></app-service-now-chat-bubble>
